const englishTranslations = {
  testReports: {
    title: "Test / Reports",
    testsOption: "Prescribed Tests",
    reportsOption: "Reports",
    noReports: "No reports found",
    reportsFetchError: "Error occurred while fetching reports",
    reportsAvailable: "Your reports are available",
    viewReportsCTA: "View",
    noRectentReports: "No reports in last 30 days",
    recentReportsRecieved: "Reports recieved in the last 30 days",
    pastReportsRecieved: "Reports received earlier than 30 days",
    doctorsComment: "Doctor's comment",
    recentReports: "Recent Reports",
    oldReports: "Old Reports",
  },
};

const marathiTranslations = {
  testReports: {
    title: "टेस्टस / रिपोर्ट्स",
    testsOption: "डॉक्टरांनुसार चाचण्या",
    reportsOption: "रिपोर्ट्स",
    noReports: "कोणतेही रिपोर्ट्स आढळले नाहीत.",
    reportsFetchError: "तांत्रिक बिघाडामुळे रिपोर्ट्स मिळाळूशकत नाही.",
    reportsAvailable: "तुमचे रिपोर्ट्स उपलब्ध आहेत",
    viewReportsCTA: "पहा",
    noReportsdays: "गेल्या 30 दिवसात कोणताही रिपोर्ट नाही",
    recentReportsRecieved: "गेल्या ३० दिवसांत प्राप्त झालेले रिपोर्ट",
    pastReportsRecieved: "३० दिवसांपूर्वी प्राप्त झालेले अहवाल",
    doctorsComment: "डॉक्टरांची टिप्पणी",
    recentReports: "नवीन रिपोर्ट",
    oldReports: "जुने रिपोर्ट",
  },
};

const hindiTranslations = {
  testReports: {
    title: "टेस्टस / रिपोर्ट्स",
    testsOption: "डॉक्टर के अनुसार टेस्ट",
    reportsOption: "रिपोर्ट्स",
    noReports: "कोई रिपोर्ट नहीं मिली।",
    reportsFetchError: "तकनीकी खराबी के कारण रिपोर्ट नहीं मिल पा रही है।",
    reportsAvailable: "आपकी रिपोर्ट उपलब्ध हैं।",
    viewReportsCTA: "देखें",
    noReportsdays: "पिछले 30 दिनों में कोई रिपोर्ट नहीं",
    recentReportsRecieved: "पिछले 30 दिनों में की गई रिपोर्ट।",
    pastReportsRecieved: "30 दिन से पहले प्राप्त रिपोर्ट",
    doctorsComment: "डॉक्टर की टिप्पणी",
    recentReports: "नया रिपोर्ट",
    oldReports: "पुरानी रिपोर्ट",
  },
};

export const translations = {
  EN: englishTranslations,
  MR: marathiTranslations,
  HI: hindiTranslations,
};
